import { TableQueryType, TableView } from 'owa-mail-list-store';

/**
 * Gets whether the everything is selected in table
 * @param tableView the table view
 * @return true if everything is selected in the table, false otherwise
 */
export default function getIsEverythingSelectedInTable(tableView: TableView): boolean {
    if (tableView.isInVirtualSelectAllMode) {
        // Always return true if user is in virtual select all mode.
        // Otherwise if a user is in select all mode and loads more items, it would switch to multi-select mode
        // and update command bar to show different items
        return true;
    }

    // VSO 17775: remove checking search table query after fixing 17775
    if (
        tableView.rowKeys.length == tableView.totalRowsInView ||
        tableView.tableQuery.type == TableQueryType.Search
    ) {
        // If client has all items or table is a search table, returns true if tableView is in multi-select mode and
        // all items are in real selection.
        return (
            tableView.isInCheckedMode && tableView.selectedRowKeys.size == tableView.rowKeys.length
        );
    }

    return false;
}
